/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trialalreadyactiveerror3Inputs */

const en_trialalreadyactiveerror3 = /** @type {(inputs: Trialalreadyactiveerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A trial is already active for this business.`)
};

const de_trialalreadyactiveerror3 = /** @type {(inputs: Trialalreadyactiveerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Unternehmen ist bereits ein Testabo aktiv.`)
};

/**
* | output |
* | --- |
* | "A trial is already active for this business." |
*
* @param {Trialalreadyactiveerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const trialalreadyactiveerror3 = /** @type {((inputs?: Trialalreadyactiveerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trialalreadyactiveerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_trialalreadyactiveerror3(inputs)
	return de_trialalreadyactiveerror3(inputs)
});
export { trialalreadyactiveerror3 as "trialAlreadyActiveError" }